import React from 'react'
import { Eating,foodmenu,ads } from '../../assets';

const Feature = () => {
  return (<>
    <div className='bg-white py-16'>
        <p className='text-md text-primary mb-5 text-center'>
            Augmented Menus
        </p>
        <h2 className='text-3xl text-primary font-bold text-center'>
        Transforming Dining Experience
        </h2>
    </div>
    <div className='flex-row bg-white md:flex gap-4 justify-center items-center text-center pb-16'>
      <div className='p-6 my-4 text-primary'>
        <div className='flex justify-center items-center text-center'><img  src={Eating} width="200"></img></div>
        <h1 className='text-lg my-2 font-semibold'>3D Food and You</h1>
        <p className='px-8'>AR makes it easier for customers to visualize the product before ordering, which makes it much more immersive</p>
      </div>
      <div className='p-6 my-4 text-primary'>
      <div className='flex justify-center items-center text-center'><img src={foodmenu} width="200"></img></div>
        <h1 className='text-lg my-2 font-semibold'>AR Food Menu</h1>
        <p className='px-8'>AR menus are great for creating the mouth-drooling experience that leads to guests actually trying new things</p>
      </div>
      <div className='p-6 my-4 text-primary'>
      <div className='flex justify-center items-center text-center'><img src={ads} width="200"></img></div>
        <h1 className='text-lg my-2 font-semibold'>3D Banner Ads</h1>
        <p className='px-8'>With spinning or moving 3D models, your content can catch the eye and drive future customers</p>
      </div>
      
    </div>
    </>
  )
}

export default Feature;